module.exports = {"helmetTitle":"Veloe - Editar Endereços","title":"Endereço principal","subtitle":"Mantenha seu endereço atualizado para sua correspondência sempre chegar direitinho.","lastSaved":"Salvo em 10/10/2017 às 19:30","modalUpdateTitle":"Pronto! A gente já salvou suas alterações. ;)","modalDeleteTitle":"Pronto! Agora, sua correspondência vai para o endereço principal."}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/EditAddress/data.json
// module id = 1738
// module chunks = 0